import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { ImportButton } from "@/features/imports/components";
interface FundsHeaderProps {
  onAddFund: () => void;
}

export const FundsHeader: React.FC<FundsHeaderProps> = ({ onAddFund }) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-3xl font-bold">Funds</h1>

      <div className="flex items-center gap-2">
        <Button className="flex items-center gap-2" onClick={onAddFund}>
          <Plus className="h-4 w-4" /> Add Fund
        </Button>
        <ImportButton context="funds" />
      </div>
    </div>
  );
};
